module.exports = __webpack_public_path__ + "static/media/icon-jcb-card.6486cb94.svg";